@if (flight) {
  <app-flight-ticket-frame class="ticket--available" tone="active" [compact]="true" [plain]="true"
    [stops]="itinerary.stops" [connections]="flight.flightSegments.length - 1"
    [departureTime]="schedule.departureTime" [arrivalTime]="schedule.arrivalTime"
    [arrivesNextDay]="schedule.arrivesNextDay" [connectionStops]="schedule.connectionStops"
    [label]="trackLabel" [cityOf]="cityOf">
    <!-- Times, direct/connection and duration sit on the route; the body adds the numbers and the seats. -->
    <strong class="ticket-flights">{{ flightNumbers }}</strong>

    <!-- One pill per segment, same four states on every flight (direct flights have one pill). -->
    <app-seat-availability class="ticket-legs" [items]="flight.flightSegments" [compactCount]="true"></app-seat-availability>

    <div class="ticket-actions">
      <button class="ticket-details-toggle" type="button" (click)="openDetails()">
        <span>Ver detalhes</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </button>
      <ng-content select="[flightSelection]"></ng-content>
    </div>
  </app-flight-ticket-frame>
}
